import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderData } from './loader.interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { trigger, transition, animate, keyframes, style } from '@angular/animations';

@Component({
  selector: 'gio-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('animation1', [
      transition('void => *', [
        style({ left: '0%' }),
        animate('0.6s', style({ left: '45%' })),
        animate('0.4s', style({ 'margin-top': '-20px' })),
      ]),
      transition('* => void', [
        style({ left: '35%' }),
        animate('0.2s', style({ 'margin-top': '0px' })),
        animate('0.8s', style({ left: '100%' }))
      ]),
    ])
  ]
})
export class LoaderComponent implements OnInit {

  message$: BehaviorSubject<string>;
  _animating = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: LoaderData
  ) { }

  ngOnInit() {
    if (typeof this.data.message === 'string') {
      this.message$ = new BehaviorSubject(this.data.message);
    } else {
      if (this.data.message instanceof BehaviorSubject) {
        this.message$ = this.data.message;
      }
    }
    setTimeout(() => {
      this._animating = true;
    }, 1);

    setInterval(() => {
      this._animating = !this._animating;
    }, 1000);
  }

  update(message: string) {
    this.message$.next(message);
  }

}
